<template>
  <div class="form-question">
    <div class="content">
      <Navbar is-logged-in />

      <div class="box-parent row m-0">
        <div class="col-sm-1 col-md-2 col-lg-3 d-none d-sm-block" />
        <div
          v-if="loadingList == true"
          class="col-12 col-md-8 col-sm-10 col-lg-6 white-box text-center mt-5"
        >
          <div
            class="spinner-border"
            role="status"
          >
            <span class="sr-only">
              Loading...
            </span>
          </div>
        </div>
        <div
          v-if="loadingList == false"
          class="col-12 col-md-8 col-sm-10 col-lg-6 white-box"
        >
          <p class="text-one text-infoy">
            <strong>
              {{ $t("form-question.text-one") }}
            </strong>
          </p>
          <div class="dynamic-assessment">
            <div
              v-for="(question, i) in listQuestion"
              :key="i"
              class="parent-question"
            >
              <p class="question">
                <strong v-if="$i18n.locale === 'en'">{{ i + 1 }}. {{ question.titleEng }}</strong>
                <strong v-if="$i18n.locale === 'id'">{{ i + 1 }}. {{ question.titleIdn }}</strong>
              </p>

              <!-- PARENT ANSWERS -->

              <textarea
                v-if="question.type === 'textbox'"
                v-model="resultQuestion[i].value"
                class="form-control ml-3 col-11"
                rows="4"
              />

              <div class="question-wrapper">
  <div 
    v-for="(questionAnswer, j) in question.questionAnswers" 
    :key="j" 
    :class="{'new-line': questionAnswer.titleEng.length > 1}"
    class="input-wrapper"
  >
    <input
      v-if="question.type === 'radio_button'"
      :ref="question.id"
      v-model="resultQuestion[i].value"
      type="radio"
      class="input-question"
      :value="questionAnswer.id"
      @change="checkChildren(i, j)"
    >
    <input
      v-if="question.type === 'checkbox'"
      :ref="question.id"
      v-model="resultQuestion[i].value"
      type="checkbox"
      class="input-question"
      :value="questionAnswer.id"
      @change="checkChildren(i, j)"
      :disabled="hasOppositeValue(i, questionAnswer.value)"
    >
    <label
      :for="questionAnswer.titleEng"
      class="label-question"
    >
      <span v-if="$i18n.locale === 'en'">{{ questionAnswer.titleEng }}</span>
      <span v-if="$i18n.locale === 'id'">{{ questionAnswer.titleIdn }}</span>
    </label>
  </div>
</div>

              <div
                v-if="!$v.resultQuestion.$each.$iter[i].required && $v.resultQuestion.$each.$iter[i].$error"
                aria-live="assertive"
              >
                <small class="text-danger">
                  {{ $t('form-question.question-required') }}
                </small>
              </div>

              <!-- CHILDREN -->

              <div
                v-if="resultQuestion[i].openChildren === true"
                class="children-box p-3"
              >
                <p class="question">
                  <strong v-if="$i18n.locale === 'en'">{{ question.children[0].titleEng }}</strong>
                  <strong v-if="$i18n.locale === 'id'">{{ question.children[0].titleIdn }}</strong>
                </p>
                <div
                  v-for="(questionChildrenAnswer, k) in question.children[0].questionAnswers"
                  :key="k"
                >
                  <input
                    v-if="question.children[0].type === 'radio_button'"
                    v-model="resultQuestionChildren[getChildrenIndex(question.id)].value"
                    type="radio"
                    class="input-question"
                    :value="questionChildrenAnswer.id"
                  >
                  <input
                    v-if="question.children[0].type === 'checkbox'"
                    v-model="resultQuestionChildren[getChildrenIndex(question.id)].value"
                    type="checkbox"
                    class="input-question"
                    :value="questionChildrenAnswer.id"
                  >
                  <label
                    :for="questionChildrenAnswer.titleEng"
                    class="label-question"
                  >
                    <span v-if="$i18n.locale === 'en'">{{ questionChildrenAnswer.titleEng }}</span>
                    <span v-if="$i18n.locale === 'id'">{{ questionChildrenAnswer.titleIdn }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="isLoadingSubmit"
            class="submit-button text-center"
          >
            <template>
              <div class="spinner-border spinner-border-sm text-center">
                <span class="sr-only">
                  Loading...
                </span>
              </div>
            </template>
          </div>
          <div
            v-if="!isLoadingSubmit"
            class="submit-button text-center"
            @click.prevent="submit"
          >
            <strong>{{ $t("form-question.button-submit") }}</strong>
          </div>
        </div>
        <div class="col-sm-1 col-md-2 col-lg-3 d-none d-sm-block" />
      </div>
    </div>
    <ModalUnsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { format } from 'date-fns'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { SURVEY_ID } from '@/fixtures'
import Api from '@/utils/Api'
import Navbar from '@/components/Navbar'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

const TYPE_INITIAL_VALUES = {
  radio_button: '',
  checkbox: [],
  textbox: ''
}

export default {
  name: 'SelfAssessment',

  components: {
    Navbar,
    ModalUnsuccessful
  },

  data () {
    return {
      listQuestion: null,
      loadingList: false,
      resultQuestion: [],
      resultQuestionChildren: [],
      isLoadingSubmit: false,
      modal: {
        unsuccessful: false,
        textModal: ''
      },
      showOther: {
        value: ''
      }
    }
  },

  created () {
    this.getQuestion()
  },

  methods: {
    async getQuestion () {
      this.loadingList = true
      const { data } = await Api.surveys.get(SURVEY_ID)
      this.listQuestion = data.questions
      this.loadingList = false
      this.initialModel()
    },
    async submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        for (const value of Object.values(this.$v.resultQuestion.$each.$iter)) {
          if (value.$error) {
            this.$refs[value.$model.id][0].focus()
            break
          }
        }
        return
      }

      this.isLoadingSubmit = true
      const { nric, location, status } = JSON.parse(localStorage.getItem('survey-meta'))
      const form = {
        date: format(new Date(), 'yyyy-MM-dd'),
        nric,
        workLocationId: location,
        workStatusId: status,
        language: this.$i18n.locale.toUpperCase(),
        surveyResponseAnswers: [
          ...this.resultQuestion.map(({ id, value, type }) => ({
            questionId: id,
            questionAnswerId: this.checkValueAnswerNotText(type, value),
            value: this.checkValueAnswerText(id, type, value)
          })),
          ...this.resultQuestionChildren.map(({ id, value }) => ({
            questionId: id,
            questionAnswerId: Array.isArray(value)
              ? value
              : [value]
          }))
        ]
      }
      const { data } = await Api.surveys.saveResponses(SURVEY_ID, form)
      this.isLoadingSubmit = false
      localStorage.removeItem('survey-meta')
      if (data.status === 40109) {
        this.modal.textModal = data.title
        this.showModal('unsuccessful')
      } else {
        this.updateNRIC(data)
        this.$router.replace({
          name: 'success-assessment',
          params: {
            assessmentResult: data
          }
        })
      }
    },
    checkValueAnswerNotText (type, value) {
      if (type !== 'textbox') {
        return Array.isArray(value) ? value : [value]
      } else {
        return ''
      }
    },
    checkValueAnswerText (id, type, value) {
      if (type === 'textbox') {
        return value
      } else {
        if (id === 'fd68d53d-e65f-40a4-a665-1e532c9e3032') {
          return this.showOther.value
        } else {
          return ''
        }
      }
    },
    initialModel () {
      this.resultQuestion = this.listQuestion.map(({ id, type }) => ({
        id,
        value: TYPE_INITIAL_VALUES[type],
        openChildren: false,
        type: type
      }))
    },
    checkChildren (question, answer) {
      const { sequence } = this.listQuestion[question].questionAnswers[answer]

      if (sequence === 1) {
        if (this.listQuestion[question].children[0] !== undefined) {
          this.resultQuestion[question].openChildren = true
          this.resultQuestionChildren.push({
            id: this.listQuestion[question].children[0].id,
            parent: this.listQuestion[question].id,
            value: this.listQuestion[question].children[0].type === 'radio_button'
              ? ''
              : []
          })
        }
      } else {
        this.resultQuestion[question].openChildren = false
        const sum = this.resultQuestionChildren.length
        if (sum !== 0) {
          let j = 0
          while (j < sum) {
            const idParent = this.resultQuestion[question].id
            const idParentInChild = this.resultQuestionChildren[j].parent
            if (idParent === idParentInChild) {
              this.resultQuestionChildren.splice(j, 1)
            }
            j++
          }
        }
      }
    },
    getChildrenIndex (parentId) {
      return this.resultQuestionChildren.findIndex(c => c.parent === parentId)
    },
    hasOppositeValue (questionIndex, value) {
      return Array.isArray(this.resultQuestion[questionIndex].value)
        ? this.resultQuestion[questionIndex].value
          .find(id => this.listQuestion[questionIndex].questionAnswers
            .find(answer => answer.id === id)
            .value !== value
          )
        : false
    },
    updateNRIC ({ nric }) {
      const prev = JSON.parse(localStorage.getItem('profile'))
      localStorage.setItem('profile', JSON.stringify({ ...prev, nric }))
    },
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      this.$router.replace({
        name: 'my_dhm'
      })
    }
  },

  validations: {
    resultQuestion: {
      required,
      $each: {
        value: {
          required: requiredIf(function (model) {
            return this.listQuestion.find(q => q.id === model.id).isRequired
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.form-question {
  background-color: #f5efff;
}
.content {
  background-image: url("../assets/image/bg-2.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
  min-height: 700px;
}
.box-parent {
  padding-top: 30px;
  position: relative;
}
.white-box {
  background: white;
  height: 100%;
  border-radius: 18px;
  margin: 0 auto;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 40px;
  padding-bottom: 40px;
  margin-bottom: 40px;
}
.text-one {
  color: #121212;
  font-family: Montserrat;
  font-size: 20px;
  line-height: 24px;
  text-align: left;
}
.text-infoy, .text-two {
  color: #121212;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.text-infoy {
  padding-bottom: 45px;
  border-bottom: 2px solid #DEDEDE;
  margin-bottom: 35px;
}
.submit-button {
  cursor: pointer;
  background-color: #18B2BD;
  height: 40px;
  border-radius: 4px;
  padding-top: 12px;
  font-size: 12px;
  color: white;
  transition: 0.5s;
}
.submit-button:hover {
  background-color: #18b2bdab;
}
.parent-question {
  margin-bottom: 20px;
}
.question {
  color: #121212;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.input-question {
  margin-right: 10px;
}
.label-question {
  font-size: 12px;
  vertical-align: middle;
  font-weight: 500;
  padding-top: 5px;
}
.children-box {
  border: 1px solid #DEDEDE;
  background-color: rgb(241, 241, 241);
}
textarea {
  resize: none;
  font-size: 12px;
}


.question-wrapper {
  display: flex;
  flex-wrap: wrap; /* Allows inputs to wrap into new lines */
}

.input-wrapper {
  margin-right: 20px;
  display: inline-flex;
  align-items: center;
}

.new-line {
  flex-basis: 100%; /* Forces input to start on a new line if title is too long */
}

.input-question {
  margin-right: 5px;
}

.label-question {
  margin-left: 5px;
}

</style>
